import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { LoginService } from "../../login/login.service";
import { LocalStorageService } from "../local-storage.service";
import { BootstrapService } from "../bootstrap/bootstrap.service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private _loginService: LoginService,
        private _localStorageService: LocalStorageService,
        private _bootstrapService: BootstrapService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const userData = this._loginService.currentUserDataValue;
        const appData = this._localStorageService.appLocalStorageExist() ? this._localStorageService.getAppLocalStorageObject() : null;
        if (userData && appData?.countries) {
            return this._bootstrapService.ensure();
        }
        // not logged in so redirect to login page with the return url
        this._loginService.logout();
        this.router.navigate(["/login"]);
        return false;
    }
}
